<div class="DocType" [class.d-none]="!isEditable || documentTypes?.length==1"
    [class.Height]="!selectedDocumentType && isEditable" *ngIf="fileDropArea">
    <app-mat-auto-search [ngModel]="selectedDocumentType" (ngModelChange)="onDocumentTypeChange($event)"
        [isEditable]="isEditable" [label]="'Document type*'" [name]="'document_type'" [displayField]="'name'"
        [idField]="null" [options]="documentTypes" *ngIf="documentTypeGroup != null" class="dropdownWidth">
    </app-mat-auto-search>
</div>

<div fxFlex="100%" class="cover" *ngIf="fileDropArea && isEditable && selectedDocumentType!=null">
    <div class="dropzone" fileDragDrop (filesChangeEmitter)="addFiles($event)">
        <div class="text-wrapper">
            <div class="centered">
                <input type="file" [accept]="selectedDocumentType.mime_accept_string" [multiple]="multiple"
                    [name]="name" (change)="addFiles($event?.target['files'])" [id]="name" [ngModel]="files"
                    (click)="this.files=[]">
                <label [for]="name"> <i MatSuffix class="i1 flaticon-solid-upload"></i>
                    <span class="center">Select your files or simply drag & drop
                        here!</span></label>
            </div>
        </div>
    </div>
    <span *ngIf=" data?.length > 0" class="fileUploadIndicator">File Uploaded: <b>{{data?.length}}
            <ng-container *ngIf="selectedDocumentType.dev_name=='tms_document'">
                <span *ngFor="let item of data">
                    <a [href]="item.document_file" target="_blank"><mat-chip class="downloadFileChip sleek-chip"
                            [style.color]="'#424041'">
                            <div class="fileName">
                                <i class="flaticon-documents"></i>{{item.original_filename}}
                            </div>
                        </mat-chip>
                    </a>
                </span>
            </ng-container>
        </b>
    </span>
    <div
        *ngIf="selectedDocumentType.dev_name=='mnr_container_images' || selectedDocumentType.dev_name=='mnr_survey_documents' || selectedDocumentType.dev_name=='repaired_container_images' || selectedDocumentType.dev_name=='csc_plate_images' || selectedDocumentType.dev_name=='tms_document'">
        <span style="margin-top: 5px;  font-size: 12px;">No of files allowed:
            <b>{{selectedDocumentType.max_files}}</b>
        </span><br>
        <span style="margin-top: 5px;  font-size: 12px;">Max File size:
            <b>{{selectedDocumentType.max_size/(1024*1024)}} MB</b>
        </span><br>
        <span style="margin-top: 5px;  font-size: 12px;"
            *ngIf="selectedDocumentType.dev_name=='mnr_survey_documents'">File types:
            <b>{{mime_accept_string_pdf}}</b>
        </span>
        <span style="margin-top: 5px;  font-size: 12px;" *ngIf="selectedDocumentType.dev_name=='tms_document'">File
            types:
            <b style="word-break: break-all;"> GIF, JPG, PNG,PDF, XLXS, XLS, DOC, DOCX, ODT, TXT, CSV, ODS, PPTX</b>
        </span>
        <span style="margin-top: 5px;  font-size: 12px;"
            *ngIf="selectedDocumentType.dev_name=='mnr_container_images' || selectedDocumentType.dev_name=='repaired_container_images' || selectedDocumentType.dev_name=='csc_plate_images'">File
            types:
            <b>{{mime_accept_string_image}}</b>
        </span>
    </div>
</div>

<div class="DocType" [class.Height]="selectedDocumentType || isEditable" *ngIf="lableUpload">
    <app-mat-auto-search [ngModel]="selectedDocumentType" (ngModelChange)="onDocumentTypeChange($event)"
        [isEditable]="isEditable" [label]="'Document type*'" [name]="'document_type'" [displayField]="'name'"
        [idField]="null" [options]="documentTypes" *ngIf="documentTypeGroup != null" class="dropdownWidth">
    </app-mat-auto-search>
</div>

<div *ngIf="!fileDropArea && isEditable && selectedDocumentType!=null" class="uploadBtn">
    <input type="file" [accept]="selectedDocumentType.mime_accept_string" (change)="addFiles($event?.target['files'])"
        (click)="this.files=[]" [multiple]="multiple" [name]="name" [id]="name" [ngModel]="files">
    <label [for]="name">
        <span class="textLink" [class.textLoader]="Soliduploading">
            <ng-container *ngIf="!Soliduploading">
                <i class="flaticon-solid-upload" *ngIf="isSolidUploadIcon">
                </i> {{label}}
            </ng-container>
            <ng-container *ngIf="Soliduploading">
                <i class="flaticon-loading spin"></i>
                Uploading...
            </ng-container>
        </span>

    </label>
</div>

<div fxFlex="100" class="table-responsive" *ngIf="showUploadedList && (data?.length || data) && !Soliduploading">
    <mat-table [dataSource]="data" class="">
        <ng-container matColumnDef="original_filename">
            <mat-header-cell *matHeaderCellDef> File Name
            </mat-header-cell>
            <mat-cell *matCellDef="let document">
                <a [href]='document?.document_file' target="_blank"
                    [download]="document?.original_filename+'.'+document?.extension">
                    {{document?.original_filename}}.{{document?.extension}}</a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="document_size">
            <mat-header-cell *matHeaderCellDef> Size</mat-header-cell>
            <mat-cell *matCellDef="let document">{{readableFileSize(document?.size)}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="document_type">
            <mat-header-cell *matHeaderCellDef> File Type</mat-header-cell>
            <mat-cell *matCellDef="let document">{{document?.document_type?.name}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="created_by">
            <mat-header-cell *matHeaderCellDef> Uploaded By</mat-header-cell>
            <mat-cell *matCellDef="let document">
                <div class="details" fxLayout="column">
                    <span class="fw-medium">
                        {{document?.created_by?.first_name}} {{document?.created_by?.last_name}}
                    </span>
                    <small>
                        {{document?.created_at | date:'dd MMM, yyyy'}}
                    </small>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> Action</mat-header-cell>
            <mat-cell *matCellDef="let document; let idx = index;">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
                    [disabled]="!isEditable">
                    <i class="flaticon-more"></i>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item>
                        <a [href]='document?.document_file' target="_blank"
                            [download]="document?.original_filename+'.'+document?.extension">
                            <span>Download File</span>
                        </a>
                    </button>
                    <button mat-menu-item (click)="removeFile(document,idx)">
                        <span>Delete File</span>
                    </button>
                </mat-menu>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <span *ngIf="data?.length===0" class="noData">No files uploaded.</span>
</div>

<!-- For Bank details in customer master only -->
<div fxFlex="100" class="table-responsive" *ngIf="bankDocList && data?.length && !Soliduploading">
    <mat-table [dataSource]="data" class="">
        <ng-container matColumnDef="original_filename">
            <mat-header-cell *matHeaderCellDef class="sidepanel_original_filename"> Document Name</mat-header-cell>
            <mat-cell *matCellDef="let document" class="sidepanel_original_filename">
                <a [href]='document?.document_file' target="_blank"
                    [download]="document?.original_filename+'.'+document?.extension">
                    {{document?.original_filename}}.{{document?.extension}}</a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef class="sidepanel_action"> Action</mat-header-cell>
            <mat-cell *matCellDef="let document; let idx = index;" class="sidepanel_action">
                <i MatSuffix class="i1 flaticon-delete" (click)="removeFile(document,idx)"></i>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns1;"></mat-row>
    </mat-table>

</div>
<ng-container *ngIf="dotFloating">
    <div fxFlex="100" class="table-responsive" style="display: flex; justify-content: center;
    align-items: center;
    overflow: hidden;
    row-gap: 8px;
    flex-direction: column-reverse;" *ngIf="Soliduploading">
        Upload in progress... Please wait. <div class="dot-floating"></div>

    </div>
</ng-container>

<div *ngIf="clipIcon && selectedDocumentType!=null">
    <input type="file" [accept]="selectedDocumentType.mime_accept_string" [multiple]="multiple" [name]="name"
        (change)="addFiles($event?.target['files'])" [id]="name" [ngModel]="files">
    <label [for]="name"><i MatSuffix class="i1 flaticon-attachment"></i></label>
</div>

<div *ngIf="cameraIcon && selectedDocumentType!=null && !cropper">
    <input type="file" [accept]="selectedDocumentType.mime_accept_string" [multiple]="multiple" [name]="name"
        (change)="addFiles($event?.target['files'])" [id]="name" [ngModel]="files">
    <label [for]="name" [class.kycIcon]='assetSource'>
        <ng-container *ngIf="assetSource">
            <logzy-img-loader *ngIf="!Soliduploading" [class.greyed]="!data " [src]="assetSource">
            </logzy-img-loader>
            <span class="prism" *ngIf="Soliduploading">
            </span>
        </ng-container>
        <i MatSuffix class="flaticon-{{flatIconClass}}"></i></label>
</div>

<div *ngIf="cameraIcon && selectedDocumentType!=null && cropper">
    <input type="file" [accept]="selectedDocumentType.mime_accept_string" [multiple]="multiple" [name]="name"
        (change)="fileChangeEvent($event)" [id]="name" [ngModel]="files">
    <label [for]="name"><i MatSuffix class="flaticon-camera"></i></label>
</div>

<div *ngIf="kycUpload && selectedDocumentType!=null" class="uploadIcon" fxFlex="100">
    <div>
        <input type="file" [accept]="selectedDocumentType.mime_accept_string" [multiple]="multiple" [name]="name"
            (change)="addFiles($event?.target['files'])" [id]="name" [ngModel]="files">
        <label [for]="name" [matTooltip]="data?.original_filename" matTooltipPosition="below">

            <i *ngIf="!data?.extension" class="flaticon-file"></i>
            <ng-container [ngSwitch]="data?.extension">
                <img src="assets/images/icons/file-type/pdf.svg" *ngSwitchCase="'pdf'">
                <img src="assets/images/icons/file-type/jpg.svg" *ngSwitchCase="'jpg'">
                <img src="assets/images/icons/file-type/png.svg" *ngSwitchCase="'png'">
                <img src="assets/images/icons/file-type/docx.svg" *ngSwitchCase="'docx'">
                <img src="assets/images/icons/file-type/gif.svg" *ngSwitchCase="'gif'">
            </ng-container>


        </label>

    </div>

</div>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{item}}</li>
</ul>